<template>
  <div :class="{ 'sidebar-categories-index': true }">
    <SidebarTopRightOrientation>
      <div class="sidebar-top-right-orientation__right">
        <button
          @click="closeSidebarCategoriesIndex"
          class="sidebar-top-right-orientation__button"
        >
          <div class="sidebar-top-right-orientation__button__text">Sluit</div>
          <svg class="sidebar-top-right-orientation__button__icon" svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-45 12 12)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(45 12 12)" d="M11 4h2v16h-2z"/></g></svg>
        </button>
      </div>
    </SidebarTopRightOrientation>

    <div class="sidebar-categories-index__bottom">
      <div class="sidebar-categories-index__bottom__titlebar">
        <SidebarTitleBar>
          <div
            class="sidebar-title-bar__icon-container"
            @click="openSidebarPositionIndex"
          >
            <svg svg-inline="" class="sidebar-title-bar__icon-container__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M16 4.462L14.603 3 6 12l8.603 9L16 19.538 8.795 12z"/></g></svg>
          </div>

          <div class="sidebar-title-bar__inner">
            <div class="sidebar-title-bar__inner__left">
              <div class="sidebar-title-bar__inner__left__title">
                Beheer categorieën
              </div>
              <div class="sidebar-title-bar__inner__left__subtitle">
                Geef hieronder aan welke categorieën je wilt weergeven in deze
                app.
              </div>
            </div>
          </div>
        </SidebarTitleBar>
      </div>

      <div class="sidebar-categories-index__ul">
        <div
          v-for="category in categories"
          :key="category.id"
          class="category-li"
          @click="toggleCategory(category)"
        >
          <img class="category-li__icon" :src="category.icon_url" />
          <div class="category-li__text">{{ category.name }}</div>
          <div :class="{ 'category-li__icon-checked': category.checked }"></div>
        </div>
      </div>
    </div>

    <portal to="page-shadow">
      <PageShadow />
    </portal>
  </div>
</template>

<script>
import PrivateApi from "@/services/PrivateApi.js";
import PageShadow from "@/components/PageShadow.vue";
import SidebarTopRightOrientation from "@/components/SidebarTopRightOrientation.vue";
import SidebarTitleBar from "@/components/SidebarTitleBar.vue";

export default {
  components: {
    SidebarTopRightOrientation,
    SidebarTitleBar,
    PageShadow
  },
  mounted() {
    let self = this;

    PrivateApi()
      .get("categories")
      .then(function(categories) {
        self.categories = categories.data;
      });
  },
  data() {
    return {
      categories: null
    };
  },
  methods: {
    closeSidebarCategoriesIndex() {
      this.$store.commit("closeSidebarCategoriesIndex");
    },
    openSidebarPositionIndex() {
      this.$store.commit("openSidebarPositionIndex");
      this.$store.commit("closeSidebarCategoriesIndex");
    },
    toggleCategory(category) {
      let self = this;

      let data = { checked: !category.checked };

      PrivateApi()
        .put(`categories/${category.id}`, data)
        .then(function() {
          let index = self.categories.findIndex(x => x.id == category.id);
          self.categories[index]["checked"] = !category.checked;
          self.$store.commit("setUpdateFeatures");
        });
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-categories-index {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: $color-gray-2;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;

  &__bottom {
    display: flex;
    flex: 1;
    width: 100%;
    overflow-y: auto;
    flex-direction: column;

    &__titlebar {
      padding: $spacing-3;
      background: #fff;
    }
  }
  &__ul {
    width: 100%;
  }
}

.category-li {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 $spacing-3;
  background: #fff;
  cursor: pointer;
  border-top: 1px solid #efefef;

  &:last-child {
    border-bottom: 1px solid #efefef;
  }

  &__icon {
    height: 48px;
    width: 48px;
    margin-right: $spacing-3;
  }

  &__text {
    @extend %text-medium;
  }

  &__state {
    margin-left: auto;
  }

  &__icon-checked {
    margin-left: auto;
    background-size: 24px 24px;
    background-image: url("../../assets/ic/icons/ic_checkmark.svg");
    width: 24px;
    height: 24px;
  }
}

@media (min-width: 768px) {
  .category-li {
    padding: 0 $spacing-4;
  }
  .sidebar-categories-index {
    &__bottom {
      &__titlebar {
        padding: $spacing-4;
      }
    }
  }
}
</style>
